const BASE_URL = "http://64.227.146.132:8080";
// const BASE_URL = "http://localhost:8080";

export async function getJobs() {
  const response = await fetch(`/api/getJobs`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
}

export async function getJob(job_id) {
  const response = await fetch(`/api/jobs/${job_id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
}

export async function createJobs(body) {
  const response = await fetch("/api/jobs", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  return response;
}

// export async function updateJob(id, formData) {
//   try {
//     const response = await fetch(`/api/jobs/${id}`, {
//       method: "PUT",
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//       body: formData,
//     });
//     return await response.json();
//   } catch (error) {
//     return error;
//   }
// }

export const updateJob = async (id, formData) => {
  try {
    const response = await fetch(`/api/jobs/${id}`, {
      method: "PUT", // or PATCH
      // body is simply the formData object
      body: formData,
      // IMPORTANT: Do NOT set 'Content-Type' header when using fetch + FormData.
      // The browser detects FormData and sets the correct boundary automatically.
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};

export async function searchJobs(data) {
  const response = await fetch("/api/searchJobs", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  return response;
}

export async function createLogin(data) {
  const response = await fetch("/api/createLogin", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  return response;
}
